import React, { Component } from 'react'
import { Row, Col, Badge, Button, Table } from 'react-bootstrap';
import './StyleOrder.css';
import {convertRiceTypeENToTH } from '../../helpers/function';
import { Redirect } from 'react-router-dom'

export default class Order1 extends Component {
  state = {
    CheckWeightSheet: {
      description: {
        description: {},
      },
    },
    FinancialSheet: {
      description: {
        description: {},
      },
    },
    paidWageSheet: {
    },
    active : [],
  }

  componentWillMount() {
    this.setState({
      FinancialSheet : this.props.FinancialSheet,
      RiceType : this.props.RiceType,
    },() => console.log(this.state))
  }
  handleButtonClick = (e,idx) => {
    let { handleButtonClick } = this.props
 
    switch (e.target.id) {
      case 'true':
        this.setState({
          active: {
            ...this.state.active,
            [idx]:true },
        }, handleButtonClick(true,idx))
        break;
      case 'false':
        this.setState({
          active: {
            ...this.state.active,
            [idx]:false },
        }, handleButtonClick(false,idx))
        break;
    }
  }
  convertText(text){
    text = text.replace(/_S/g,' ')
    text = text.replace(/_D/g,'.')
    text = text.replace(/_P/g,'%')
    text = text.replace(/_B/g,'/')
    if(text === 'blank'){
      return null
    }else{
      return text
    }
  }
  renderStandardCiteria(arr,idx){
    if(arr){
      return(
        Object.keys(arr[0]).map((titleText,idz) => {
          if(this.convertText(arr[0][titleText]) !== '-' && arr[0][titleText] != 'blank'){
            return <tr><td>{this.convertText(titleText).slice(2,titleText.lenght)}</td><td>{this.convertText(arr[0][titleText])}</td><td><input id={Object.keys(arr[1])[idz]} onChange={(e) => {this.props.handleExtra(e,idx)}}></input></td></tr>
          }
          else if(arr[0][titleText] == 'blank'){
            return <tr><td><b>{this.convertText(titleText).slice(2,titleText.lenght)}</b></td><td></td><td></td></tr>
          }
          else{
            return <tr><td>{this.convertText(titleText).slice(2,titleText.lenght)}</td><td>{this.convertText(arr[0][titleText])}</td><td><input id={Object.keys(arr[1])[idz]} onChange={(e) => {this.props.handleExtra(e,idx)}}></input></td></tr>
          }
        })  
      )  
    }else{
      return <div/>
    }
  }
  render() {
    let { FinancialSheet,RiceType } = this.state;
    if(FinancialSheet.description && RiceType){
      return (
        <div>
          {FinancialSheet.description.description.map((data,idx) => (
            <div className="TopSpace">
              <Row>
                <Col align="center">
                  <h3><Badge variant="primary">License No :<br />{data.licenseID}</Badge></h3><br />                  
                  <div align="left">
                      Shipper : {FinancialSheet.description.companyID} <br />
                      Supplier : {FinancialSheet.description.requestBy}<br />
                      Ex rice mill / godown: {FinancialSheet.description.surveyLocateName}<br />
                      Quality said tone : {convertRiceTypeENToTH(data.riceTypeID)} <br />
                      Vessel : {data.vehicleName} Destination : {data.destinationCity} <br />
                      Gross weight : {data.grossWeight} Ton<br />
                      Tar weight      :        {data.grossWeight - data.netWeight } Ton<br />
                      Net weight     : {data.netWeight} Ton<br />
                  </div>
                </Col>
  
                <Col>
                  <Table className="table table-bordered">
                    <thead className="thead-dark">
                      <tr>
                        <th scope="col">รายการวิเคราะห์</th>
                        <th scope="col">ค่ามาตรฐาน</th>
                        <th scope="col">ผลวิเคราะห์</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.renderStandardCiteria(RiceType[data['riceTypeID']],idx)}
                    </tbody>
                  </Table>
                  <Row align="center">
                    <Col align="center">
                      <Button variant="secondary" size="lg" >ยกเลิก</Button>
                    </Col>
                    <Col align="center">
                      <Button variant="success" size="lg" onClick={this.props.handleSubmit} >บันทึกผล</Button><br /><br />
                    </Col>
                  </Row>
                  <Row align="center">
                      
                  </Row>
                </Col>
              </Row>
            </div>
          ))}
        </div>
      )
    }else{
      return  <Redirect to="/ValidPage"/>
    }
  }

}
